export const tenantThemes = {
  kaniva: () => import('./kaniva/theme.scss'),
  mudjai: () => import('./mudjai/theme.scss'),
}

export type Tenant = keyof typeof tenantThemes
